import { render, staticRenderFns } from "./PopoverOwner.vue?vue&type=template&id=1a35d4b5&scoped=true&"
import script from "./PopoverOwner.vue?vue&type=script&lang=js&"
export * from "./PopoverOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35d4b5",
  null
  
)

export default component.exports